<template>
    <div class="payment-container">
        <div v-if="url.length && access_code.length">
            <h2><img src="/images/icon-visamastercard.jpg"> Credit Card</h2>
            <div class="row">
                <div class="col-md-12">
                    <txt label="card_name" v-model="model.card_name"></txt>
                </div>
            </div>
            <div class="row">
                <div class="col-md-9">
                    <txt label="card_number" v-model="model.card_number"></txt>
                </div>
                <div class="col-md-3">
                    <txt label="cvv" v-model="model.cvv"></txt>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <list label="expiration_month" v-model="model.expiration_month" :list="months" :usekey="true"></list>
                </div>
                <div class="col-md-6">
                    <list label="expiration_year" v-model="model.expiration_year" :list="years"></list>
                </div>
            </div>
            <div class="row payment-icons" v-if="cards">
                <div class="col-md-7">
                    <div class="pull-right">
                        <img v-for="card in cards" :src="card['source']" :alt="card['alt']" style="width: 70px; display: inline; margin-right: 6px;"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-md-offset-4 buttons section">
                    <button class="btn btn-success btn-sml" @click="store">Pay Now</button>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="error.length" class="alert alert-danger">
                <strong>Error</strong> Please contact us.<br />
                <strong>Reason:</strong> {{ error }}
            </div>
            <div v-else>
                Loading <i class="icon icon-spinner fa-spin"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: { public_id: {default: ''} },
        data: function() {
            return {
                error: '',
                url: '',
                access_code: '',
                cards: [],
                years: [ 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035 ],
                months: {
                    1: '01 - January',
                    2: '02 - February',
                    3: '03 - March',
                    4: '04 - April',
                    5: '05 - May',
                    6: '06 - June',
                    7: '07 - July',
                    8: '08 - August',
                    9: '09 - September',
                    10: '10 - October',
                    11: '11 - November',
                    12: '12 - December',
                },
                model: {
                    card_name: '',
                    card_number: '',
                    cvv: '',
                    expiration_month: '',
                    expiration_year: '',
                }
            }
        },
        created() {
            this.axios.get(window.gateway_url, { params: {
                public_id: this.public_id
            }}).then((response) => {
                let data  = response.data;
                if (typeof data.url !== 'undefined' && typeof data.access_code !== 'undefined') {
                    this.url = response.data.url;
                    this.access_code = response.data.access_code;
                    this.cards = response.data.acceptedCreditCardTypes;
                }
                if (typeof data.error !== 'undefined') {
                    this.error = data.error;
                }
                // do something
                console.log(response);
            }).catch((error) => {
                console.log(error);
            });
        },
        methods: {
            store() {
//                require('https://api.ewaypayments.com/JSONP/v3/js');
                //https://api.ewaypayments.com/JSONP/v3/js
//                this.$store('/api/payment-gateways/store', this.model);
                this.post(this.url, this.eway(), 'POST')
            },
            eway() {
                let eway = {};
                eway.EWAY_ACCESSCODE = this.access_code;
                eway.EWAY_CARDNAME = this.model.card_name;
                eway.EWAY_CARDNUMBER = this.model.card_number.replace(/ /g,'');
                eway.EWAY_CARDCVN = this.model.cvv;
                eway.EWAY_CARDEXPIRYMONTH = this.model.expiration_month;
                eway.EWAY_CARDEXPIRYYEAR = this.model.expiration_year;
                return eway;
            },
            post(path, params, method) {
                method = method || "post"; // Set method to post by default if not specified.

                // The rest of this code assumes you are not using a library.
                // It can be made less wordy if you use one.
                let form = document.createElement("form");
                form.setAttribute("method", method);
                form.setAttribute("action", path);

                for(let key in params) {
                    if(params.hasOwnProperty(key)) {
                        let hiddenField = document.createElement("input");
                        hiddenField.setAttribute("type", "hidden");
                        hiddenField.setAttribute("name", key);
                        hiddenField.setAttribute("value", params[key]);

                        form.appendChild(hiddenField);
                    }
                }

                document.body.appendChild(form);
                form.submit();
            }
        },
        components: {
            'txt': require('../../../components/form/text.vue').default,
            'list': require('../../../components/form/list.vue').default
        }
    }
</script>